import {
  FETCH_GANGSTA_REQUEST,
  FETCH_GANGSTA_RECEIVED,
  FETCH_GANGSTA_FAIL,
  FETCH_FILTER_DATA_REQUEST,
  FETCH_FILTER_DATA_RECEIVED,
  FETCH_FILTER_DATA_FAIL,
  FETCH_QUERY_RECIEVED,
  SET_CURRENT_PAGE,
  FETCH_ACCUMULATED_GBET_PENDING,
  FETCH_ACCUMULATED_GBET_RECEIVED,
  FETCH_ACCUMULATED_GBET_FAIL,
} from "../actions/marketplace.js";

const defaultState = {
  isLoading: false,
  fetchError: "",
  data: {},
  filterData: [],
  filterDataError: "",
  isFilterLoading: false,
  isAccumulatedGBETLoading: false,
  isAccumulatedGBETError: false,
  accumulatedGBETs: null,
  query: "",
  currentPage: 1,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ACCUMULATED_GBET_PENDING:
      return {
        ...state,
        isAccumulatedGBETError: false,
        isAccumulatedGBETLoading: true,
      };

    case FETCH_ACCUMULATED_GBET_RECEIVED:
      return {
        ...state,
        accumulatedGBETs: action.data,
        isAccumulatedGBETError: false,
        isAccumulatedGBETLoading: false,
      };

    case FETCH_ACCUMULATED_GBET_FAIL:
      return {
        ...state,
        isAccumulatedGBETError: action.error,
        isAccumulatedGBETLoading: false,
      };
    //--

    case FETCH_GANGSTA_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchError: "",
      };

    case FETCH_GANGSTA_RECEIVED:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        fetchError: "",
      };

    case FETCH_GANGSTA_FAIL:
      return {
        ...state,
        fetchError: action.error,
        isLoading: false,
      };

    case FETCH_FILTER_DATA_REQUEST:
      return {
        ...state,
        isFilterLoading: true,
        filterDataError: "",
      };

    case FETCH_FILTER_DATA_RECEIVED:
      return {
        ...state,
        filterData: action.data,
        isFilterLoading: false,
        filterDataError: "",
      };

    case FETCH_FILTER_DATA_FAIL:
      return {
        ...state,
        isFilterLoading: false,
        filterDataError: action.error,
      };

    case FETCH_QUERY_RECIEVED:
      console.log("mp query");
      console.log(action.data);
      return {
        ...state,
        query: action.data?.replaceAll(" ", "%20"),
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.data,
      };

    default:
      return state;
  }
};

export default reducer;
